import { Container, Geometry, Mesh, Shader, Texture } from "pixi.js";
import { RayOptions } from "../filters/TextRayFilter/RayOptions";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import textRayVert from "./shader/textray.vert";
import textRayFrag from "./shader/textray.frag"

export class RayLightContainer extends Container {
    public readonly options: RayOptions;
    public set lightX(value: number) {
        this.options.light.posX = value;
        this.shader.uniforms.u_light_pos_x = value;
    }
    public get lightX(): number {
        return this.options.light.posX;
    }
    public set lightY(value: number) {
        this.options.light.posY = value;
        this.shader.uniforms.u_light_pos_y = value;
    }
    public get lightY(): number {
        return this.options.light.posY;
    }
    public set lightPower(value: number) {
        this.options.light.power = value;
        this.shader.uniforms.u_light_power = value;
    }
    public get lightPower(): number {
        return this.options.light.power;
    }
    public set lightGrain(value: number) {
        this.options.light.grain = value;
        this.shader.uniforms.u_grain = value;
    }
    public get lightGrain(): number {
        return this.options.light.grain;
    }
    public set lightLength(value: number) {
        this.options.light.length = value;
        this.shader.uniforms.u_light_length = value;
    }
    public get lightLength(): number {
        return this.options.light.length;
    }

    private readonly canvasScaler: ICanvasScaler; 
    private readonly shader: Shader;

    public constructor(canvasScaler: ICanvasScaler, target: Texture, options?: RayOptions) {
        super();
        this.canvasScaler = canvasScaler;
        options = {
            size: 7,
            opacityThreshold: 0.2,
            samplingPower: 1.5,
            preDefColor: 0.7,
            originalLight: 1.1,
            glowColor: [1, 1, 1],
            ...options,
            light: {
                posX: 0.0,
                posY: 5,
                length: 0.35,
                grain: 0.03,
                power: 2.5,
                ...options?.light
            }
        };
        this.options = options;
        const geometry = new Geometry();
        geometry.addAttribute("aVertexPosition", [0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0], 2);
        geometry.addAttribute("aTextureCoord", [0, 0, 1, 0, 1, 1, 0, 1], 2);
        geometry.addIndex([0, 1, 2, 0, 2, 3]);
        const uniforms = {
            u_canvas_ratio: canvasScaler.referenceHeight / canvasScaler.referenceWidth,
            u_pic_ratio: target.width / target.height,
            u_texture: target,
            u_pic_size: options.size,
            u_threshold: options.opacityThreshold,
        
            u_light_length: options.light.length,
            u_grain: options.light.grain,
            u_light_power: options.light.power,
            u_light_pos_x: options.light.posX,
            u_light_pos_y: options.light.posY,
        
            u_sampling_pow: options.samplingPower,
        
            u_predef_color: options.preDefColor,
            u_image_lighting: options.originalLight,
            u_glow_color: options.glowColor
          };
        
          this.shader = Shader.from(textRayVert, textRayFrag, uniforms);
          const mesh = new Mesh(geometry, this.shader);
          mesh.scale.set(canvasScaler.referenceWidth, canvasScaler.referenceHeight);
          this.addChild(mesh);
    }

}

